import { userStorage } from '../lib/userStorage';

export const CUSTOM_THEME_KEYS = {
  school: 'custom_theme_school',
  accent: 'custom_theme_accent',
  palette: 'custom_theme_palette',
  background: 'custom_theme_background',
  font: 'custom_theme_font',
};

export const DEFAULT_CUSTOM_THEME = {
  school: '',
  accent: '',
  palette: 'default',
  background: 'calm',
  font: 'poppins',
};

export const FONT_PRESETS = [
  { id: 'poppins', name: 'Poppins', description: 'Clean and modern', stack: "'Poppins', sans-serif" },
  { id: 'inter', name: 'Inter', description: 'Focused and readable', stack: "'Inter', sans-serif" },
  { id: 'nunito', name: 'Nunito', description: 'Soft and friendly', stack: "'Nunito', sans-serif" },
  { id: 'lora', name: 'Lora', description: 'Calm editorial', stack: "'Lora', serif" },
  { id: 'gowun', name: 'Gowun Batang', description: 'Gentle and academic', stack: "'Gowun Batang', serif" },
];

export const CALM_ACCENT_PALETTES = [
  { id: 'blue', name: 'Calm Blue', accent: '#2B7AE8' },
  { id: 'green', name: 'Soft Green', accent: '#3A7D5A' },
  { id: 'rose', name: 'Muted Rose', accent: '#B75D69' },
  { id: 'gold', name: 'Warm Gold', accent: '#A97822' },
  { id: 'violet', name: 'Quiet Violet', accent: '#6B5AAE' },
  { id: 'teal', name: 'Deep Teal', accent: '#2F7F82' },
  { id: 'graphite', name: 'Graphite', accent: '#4B5563' },
];

export const SCHOOL_COLOR_PRESETS = {
  'arizona state university': { accent: '#8C1D40', secondary: '#FFC627' },
  'auburn university': { accent: '#0C2340', secondary: '#F26522' },
  'baylor university': { accent: '#154734', secondary: '#FFB81C' },
  'boston college': { accent: '#8A100B', secondary: '#B29D6C' },
  'boston university': { accent: '#CC0000', secondary: '#2D2926' },
  'brigham young university': { accent: '#002E5D', secondary: '#FFFFFF' },
  'brown university': { accent: '#4E3629', secondary: '#ED1C24' },
  'california institute of technology': { accent: '#FF6C0C', secondary: '#76777B' },
  'carnegie mellon university': { accent: '#C41230', secondary: '#1E1E1E' },
  'clemson university': { accent: '#F56600', secondary: '#522D80' },
  'columbia university in the city of new york': { accent: '#B9D9EB', secondary: '#1D4F91' },
  'cornell university': { accent: '#B31B1B', secondary: '#222222' },
  'dartmouth college': { accent: '#00693E', secondary: '#12312B' },
  'duke university': { accent: '#00539B', secondary: '#012169' },
  'emory university': { accent: '#012169', secondary: '#C5A74F' },
  'florida state university': { accent: '#782F40', secondary: '#CEB888' },
  'georgetown university': { accent: '#041E42', secondary: '#63666A' },
  'georgia institute of technology-main campus': { accent: '#B3A369', secondary: '#003057' },
  'harvard university': { accent: '#A51C30', secondary: '#1E1E1E' },
  'indiana university-bloomington': { accent: '#990000', secondary: '#EEEDEB' },
  'johns hopkins university': { accent: '#002D72', secondary: '#68ACE5' },
  'louisiana state university and agricultural & mechanical college': { accent: '#461D7C', secondary: '#FDD023' },
  'massachusetts institute of technology': { accent: '#A31F34', secondary: '#8A8B8C' },
  'michigan state university': { accent: '#18453B', secondary: '#FFFFFF' },
  'new york university': { accent: '#57068C', secondary: '#000000' },
  'northeastern university': { accent: '#D41B2C', secondary: '#000000' },
  'northwestern university': { accent: '#4E2A84', secondary: '#836EAA' },
  'ohio state university-main campus': { accent: '#BB0000', secondary: '#666666' },
  'pennsylvania state university-main campus': { accent: '#1E407C', secondary: '#96BEE6' },
  'pepperdine university': { accent: '#00205B', secondary: '#EE7624' },
  'princeton university': { accent: '#FF8F00', secondary: '#000000' },
  'purdue university-main campus': { accent: '#CEB888', secondary: '#000000' },
  'rice university': { accent: '#00205B', secondary: '#C1C6C8' },
  'stanford university': { accent: '#8C1515', secondary: '#4D4F53' },
  'syracuse university': { accent: '#D44500', secondary: '#000E54' },
  'texas a & m university-college station': { accent: '#500000', secondary: '#FFFFFF' },
  'the university of alabama': { accent: '#9E1B32', secondary: '#828A8F' },
  'the university of texas at austin': { accent: '#BF5700', secondary: '#333F48' },
  'tufts university': { accent: '#3E8EDE', secondary: '#FFFFFF' },
  'tulane university of louisiana': { accent: '#006747', secondary: '#418FDE' },
  'university of arizona': { accent: '#AB0520', secondary: '#0C234B' },
  'university of california-berkeley': { accent: '#003262', secondary: '#FDB515' },
  'university of california-davis': { accent: '#022851', secondary: '#FFBF00' },
  'university of california-irvine': { accent: '#0064A4', secondary: '#FFD200' },
  'university of california-los angeles': { accent: '#2774AE', secondary: '#FFD100' },
  'university of california-san diego': { accent: '#182B49', secondary: '#FFCD00' },
  'university of california-santa barbara': { accent: '#003660', secondary: '#FEBC11' },
  'university of chicago': { accent: '#800000', secondary: '#767676' },
  'university of colorado boulder': { accent: '#CFB87C', secondary: '#000000' },
  'university of florida': { accent: '#0021A5', secondary: '#FA4616' },
  'university of georgia': { accent: '#BA0C2F', secondary: '#000000' },
  'university of illinois urbana-champaign': { accent: '#13294B', secondary: '#FF5F05' },
  'university of maryland-college park': { accent: '#E03A3E', secondary: '#FFD520' },
  'university of miami': { accent: '#F47321', secondary: '#005030' },
  'university of michigan-ann arbor': { accent: '#00274C', secondary: '#FFCB05' },
  'university of north carolina at chapel hill': { accent: '#4B9CD3', secondary: '#13294B' },
  'university of notre dame': { accent: '#0C2340', secondary: '#C99700' },
  'university of oregon': { accent: '#154733', secondary: '#FEE123' },
  'university of pennsylvania': { accent: '#011F5B', secondary: '#990000' },
  'university of pittsburgh-pittsburgh campus': { accent: '#003594', secondary: '#FFB81C' },
  'university of southern california': { accent: '#990000', secondary: '#FFC72C' },
  'university of virginia-main campus': { accent: '#232D4B', secondary: '#E57200' },
  'university of washington-seattle campus': { accent: '#4B2E83', secondary: '#B7A57A' },
  'university of wisconsin-madison': { accent: '#C5050C', secondary: '#646569' },
  'vanderbilt university': { accent: '#866D4B', secondary: '#000000' },
  'villanova university': { accent: '#00205B', secondary: '#13A3E8' },
  'virginia polytechnic institute and state university': { accent: '#861F41', secondary: '#E5751F' },
  'wake forest university': { accent: '#9E7E38', secondary: '#000000' },
  'washington university in st louis': { accent: '#A51417', secondary: '#3D3D3D' },
  'yale university': { accent: '#00356B', secondary: '#286DC0' },
};

const GENERATED_SCHOOL_ACCENTS = [
  '#2F6F9F',
  '#3A7D5A',
  '#8C4A64',
  '#7B5BA7',
  '#A15C38',
  '#2F7F82',
  '#7B6D3A',
  '#4B6F44',
  '#6F5A8C',
  '#9A4D4D',
  '#3D668C',
  '#746A9C',
  '#507C78',
  '#8A6A32',
  '#5F6F8F',
  '#874E75',
  '#476D58',
  '#7A5748',
];

const CUSTOM_THEME_EVENT = 'maiCollegesCustomThemeChange';
const THEME_STYLE_KEYS = [
  '--ds-font-family',
  '--ds-active-color',
  '--ds-active-bg',
  '--ds-active-bg-hover',
  '--ds-primary-200',
  '--ds-primary-300',
  '--ds-theme-accent',
  '--ds-theme-accent-soft',
  '--ds-theme-accent-softer',
  '--ds-theme-accent-muted',
  '--ds-theme-gradient',
];

function normalizeSchoolName(name = '') {
  return String(name).trim().toLowerCase().replace(/\s+/g, ' ');
}

function hashString(value) {
  return normalizeSchoolName(value).split('').reduce((hash, char) => {
    return ((hash << 5) - hash + char.charCodeAt(0)) | 0;
  }, 0);
}

function readValue(key, fallback = '') {
  try {
    return userStorage.getItem(key) || fallback;
  } catch {
    return fallback;
  }
}

function writeValue(key, value) {
  try {
    if (value) {
      userStorage.setItem(key, value);
    } else {
      userStorage.removeItem(key);
    }
  } catch {
    // Ignore storage failures.
  }
}

function clamp(value, min = 0, max = 255) {
  return Math.min(max, Math.max(min, value));
}

function hexToRgb(hex) {
  const clean = String(hex || '').replace('#', '').trim();
  if (!/^[0-9a-fA-F]{6}$/.test(clean)) return null;
  return {
    r: parseInt(clean.slice(0, 2), 16),
    g: parseInt(clean.slice(2, 4), 16),
    b: parseInt(clean.slice(4, 6), 16),
  };
}

function rgbToHex({ r, g, b }) {
  return `#${[r, g, b].map((value) => clamp(Math.round(value)).toString(16).padStart(2, '0')).join('')}`;
}

function mixWithWhite(hex, amount = 0.86) {
  const rgb = hexToRgb(hex);
  if (!rgb) return '#EBF3FF';
  return rgbToHex({
    r: rgb.r + (255 - rgb.r) * amount,
    g: rgb.g + (255 - rgb.g) * amount,
    b: rgb.b + (255 - rgb.b) * amount,
  });
}

function mixWithBlack(hex, amount = 0.18) {
  const rgb = hexToRgb(hex);
  if (!rgb) return '#2B7AE8';
  return rgbToHex({
    r: rgb.r * (1 - amount),
    g: rgb.g * (1 - amount),
    b: rgb.b * (1 - amount),
  });
}

function mixColors(hexA, hexB, amount = 0.5) {
  const a = hexToRgb(hexA);
  const b = hexToRgb(hexB);
  if (!a || !b) return hexA || hexB;
  return rgbToHex({
    r: a.r + (b.r - a.r) * amount,
    g: a.g + (b.g - a.g) * amount,
    b: a.b + (b.b - a.b) * amount,
  });
}

export function getSchoolColorPreset(schoolName) {
  return SCHOOL_COLOR_PRESETS[normalizeSchoolName(schoolName)] || null;
}

export function getSchoolAccentSuggestion(schoolName) {
  const preset = getSchoolColorPreset(schoolName);
  if (preset) return { ...preset, source: 'preset' };

  if (!normalizeSchoolName(schoolName)) return null;

  const hash = Math.abs(hashString(schoolName));
  const accent = GENERATED_SCHOOL_ACCENTS[hash % GENERATED_SCHOOL_ACCENTS.length];
  const secondary = GENERATED_SCHOOL_ACCENTS[(hash + 7) % GENERATED_SCHOOL_ACCENTS.length];
  return { accent, secondary, source: 'generated' };
}

export function readCustomTheme() {
  return {
    school: readValue(CUSTOM_THEME_KEYS.school, DEFAULT_CUSTOM_THEME.school),
    accent: readValue(CUSTOM_THEME_KEYS.accent, DEFAULT_CUSTOM_THEME.accent),
    palette: readValue(CUSTOM_THEME_KEYS.palette, DEFAULT_CUSTOM_THEME.palette),
    background: readValue(CUSTOM_THEME_KEYS.background, DEFAULT_CUSTOM_THEME.background),
    font: readValue(CUSTOM_THEME_KEYS.font, DEFAULT_CUSTOM_THEME.font),
  };
}

export function saveCustomTheme(theme) {
  const nextTheme = { ...DEFAULT_CUSTOM_THEME, ...theme };
  Object.entries(CUSTOM_THEME_KEYS).forEach(([field, key]) => {
    writeValue(key, nextTheme[field]);
  });
  applyCustomTheme(nextTheme);
  window.dispatchEvent(new CustomEvent(CUSTOM_THEME_EVENT, { detail: nextTheme }));
  return nextTheme;
}

export function resetCustomTheme() {
  Object.values(CUSTOM_THEME_KEYS).forEach((key) => writeValue(key, ''));
  applyCustomTheme(DEFAULT_CUSTOM_THEME);
  window.dispatchEvent(new CustomEvent(CUSTOM_THEME_EVENT, { detail: DEFAULT_CUSTOM_THEME }));
}

export function getPaletteById(paletteId) {
  return CALM_ACCENT_PALETTES.find((palette) => palette.id === paletteId) || CALM_ACCENT_PALETTES[0];
}

export function getFontById(fontId) {
  return FONT_PRESETS.find((font) => font.id === fontId) || FONT_PRESETS[0];
}

export function getAccentForTheme(theme = readCustomTheme()) {
  if (theme.accent && hexToRgb(theme.accent)) return theme.accent;
  const suggestion = getSchoolAccentSuggestion(theme.school);
  if (suggestion?.accent) return suggestion.accent;
  if (theme.palette && theme.palette !== 'default') return getPaletteById(theme.palette).accent;
  return '';
}

export function applyCustomTheme(theme = readCustomTheme()) {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  const accent = getAccentForTheme(theme);
  const backgroundAccent = accent || CALM_ACCENT_PALETTES[0].accent;
  const font = getFontById(theme.font);

  THEME_STYLE_KEYS.forEach((key) => root.style.removeProperty(key));
  root.style.setProperty('--ds-font-family', font.stack);
  root.classList.toggle('custom-theme-active', Boolean(accent));
  root.classList.toggle('custom-theme-calm-bg', theme.background === 'calm');

  const isDarkMode = root.classList.contains('dark');
  const backgroundSoft = isDarkMode
    ? mixColors('#141414', backgroundAccent, 0.18)
    : mixWithWhite(backgroundAccent, 0.9);
  const backgroundSofter = isDarkMode
    ? mixColors('#141414', backgroundAccent, 0.11)
    : mixWithWhite(backgroundAccent, 0.96);
  const themeGradient = isDarkMode
    ? `radial-gradient(ellipse at 14% -8%, ${backgroundSoft} 0, transparent 68%), radial-gradient(ellipse at 96% -6%, ${backgroundSofter} 0, transparent 64%), linear-gradient(135deg, transparent 0%, ${backgroundSofter} 48%, transparent 86%)`
    : `radial-gradient(circle at 12% 2%, ${mixWithWhite(backgroundAccent, 0.74)} 0, ${mixWithWhite(backgroundAccent, 0.86)} 22%, transparent 42%), radial-gradient(circle at 88% 0%, ${mixWithWhite(backgroundAccent, 0.82)} 0, ${mixWithWhite(backgroundAccent, 0.92)} 24%, transparent 44%), linear-gradient(135deg, transparent 0%, ${mixWithWhite(backgroundAccent, 0.97)} 44%, transparent 82%)`;

  root.style.setProperty('--ds-theme-gradient', themeGradient);

  if (!accent) return;

  const readableAccent = isDarkMode ? mixWithWhite(accent, 0.42) : mixWithBlack(accent, 0.12);
  const activeBg = isDarkMode ? mixColors('#141414', accent, 0.26) : mixWithWhite(accent, 0.88);
  const activeBgHover = isDarkMode ? mixColors('#141414', accent, 0.34) : mixWithWhite(accent, 0.82);
  const soft = isDarkMode ? mixColors('#141414', accent, 0.18) : mixWithWhite(accent, 0.9);
  const softer = isDarkMode ? mixColors('#141414', accent, 0.11) : mixWithWhite(accent, 0.96);
  const borderSoft = isDarkMode ? mixColors('#2A2A2A', accent, 0.38) : mixWithWhite(accent, 0.74);
  const borderMedium = isDarkMode ? mixColors('#555555', accent, 0.28) : mixWithWhite(accent, 0.54);

  root.style.setProperty('--ds-active-color', readableAccent);
  root.style.setProperty('--ds-active-bg', activeBg);
  root.style.setProperty('--ds-active-bg-hover', activeBgHover);
  root.style.setProperty('--ds-primary-200', borderSoft);
  root.style.setProperty('--ds-primary-300', borderMedium);
  root.style.setProperty('--ds-theme-accent', readableAccent);
  root.style.setProperty('--ds-theme-accent-soft', soft);
  root.style.setProperty('--ds-theme-accent-softer', softer);
  root.style.setProperty('--ds-theme-accent-muted', isDarkMode ? mixWithWhite(accent, 0.28) : mixWithBlack(accent, 0.3));
}

export function subscribeToCustomTheme(callback) {
  const handleThemeEvent = (event) => callback(event.detail || readCustomTheme());
  const handleStorage = (event) => {
    if (Object.values(CUSTOM_THEME_KEYS).includes(event.key)) callback(readCustomTheme());
  };

  window.addEventListener(CUSTOM_THEME_EVENT, handleThemeEvent);
  window.addEventListener('storage', handleStorage);

  return () => {
    window.removeEventListener(CUSTOM_THEME_EVENT, handleThemeEvent);
    window.removeEventListener('storage', handleStorage);
  };
}
